module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_682.b332d709.webp";